export const SVG_CIRCLE_CATEGORY_KEY = 'svg' as const;
export const SVG_CIRCLE_COMPONENT_KEY = 'svgCircle' as const;
